import React from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import TemplateList from './TemplateList';
import TemplateUploadView from '../TemplateUpload/TemplateUploadView';
import TemplateUpdateView from '../TemplateUpdate';
import Template from './Template';
import TemplateEdit from './TemplateEdit';
import Viewer from '../Viewer';
import PageContentError from '../UI/PageContentError';

const TemplateRoute = () => {
  const match = useRouteMatch();
  const { path } = match;
  return (
    <Switch>
      <Route exact path={path} component={TemplateList} />
      <Route exact path={`${path}/new`} component={TemplateUploadView} />
      <Route path={`${path}/update/:number`} component={TemplateUpdateView} />
      <Route path={`${path}/edit/:number`} component={TemplateEdit} />
      <Route path={`${path}/view/:number`}>
        {(props) => <Viewer {...props} type='template' />}
      </Route>
      <Route path={`${path}/:number`} component={Template} />
      <Route path='*' component={PageContentError} />
    </Switch>
  );
};

export default TemplateRoute;
